import { useMemo, useRef, useState } from "react";

const EPS = 0.5;

export function useSyncHeight(count: number) {
    const outerRef = useRef<(HTMLElement | null)[]>([]);
    const measureRef = useRef<(HTMLElement | null)[]>([]);
    const heightsRef = useRef<number[]>([]);
    const [height, setHeight] = useState(0);

    const observer = useMemo(() => new ResizeObserver(entries => {
        let didChange = false;

        for (const entry of entries) {
            const index = measureRef.current.findIndex((el) => el === entry.target);
            if (index === -1) continue;

            const h = entry.contentRect.height;
            if (heightsRef.current[index] == null || Math.abs(heightsRef.current[index] - h) >= EPS) {
                heightsRef.current[index] = h;
                didChange = true;
            }
        }

        if (!didChange) return;

        let max = 0;
        for (let i = 0; i < count; i++) {
            const h = heightsRef.current[i] ?? 0;
            if (h > max) max = h;
        }

        for (let i = 0; i < count; i++) {
            const outer = outerRef.current[i];
            if (!outer) continue;
            outer.style.height = `${max}px`;
        }

        setHeight(max);
    }), [count]);

    const reconnectObserver = () => {
        observer.disconnect();
        for (let i = 0; i < count; i++) {
            const measureElement = measureRef.current[i];
            if (measureElement) observer.observe(measureElement);
        }
    };

    return {
        height,
        registerOuter: (index: number, el: HTMLElement | null) => {
            outerRef.current[index] = el;
        },
        registerMeasure: (index: number, el: HTMLElement | null) => {
            measureRef.current[index] = el;
            reconnectObserver();
        },
    };
}
